import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Logger, LoggingService, LogLevel } from '../logging/logging.service';
import { CurafidaAuthService } from '../authentication/curafida-auth.service';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';

@Injectable({
    providedIn: 'root',
})
export class LoginGuardService {
    protected readonly log: Logger;

    constructor(
        protected authService: CurafidaAuthService,
        private router: Router,
        private loggingService: LoggingService,
        private splashScreenStateService: SplashScreenStateService,
    ) {
        this.log = this.loggingService.getLogger('LoginGuardService');
        this.log.setLevel(LogLevel.DEBUG);
    }

    async canActivate(): Promise<UrlTree | boolean> {
        // Check authenticated state
        const isAuthenticated = this.authService.isAuthenticated();
        if (isAuthenticated) {
            this.log.debug(`[canActivate] User is already authenticated. Navigate to root /`);
            return this.router.parseUrl('/');
        }
        this.log.info(`[canActivate] User is NOT authenticated. Stay on /login and return true.`);
        this.splashScreenStateService.splashScreenIsEnabled.set(false);
        return true;
    }
}
